/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrderTypeAdditionServiceRespVo
 */
export interface OrderTypeAdditionServiceRespVo {
    /**
     * 主键 ID
     * @type {number}
     * @memberof OrderTypeAdditionServiceRespVo
     */
    id?: number;
    /**
     * 订单类型
     * @type {number}
     * @memberof OrderTypeAdditionServiceRespVo
     */
    orderType?: number;
    /**
     * 订单类型的附加服务组id [1,2,3,4]
     * @type {Array<number>}
     * @memberof OrderTypeAdditionServiceRespVo
     */
    additionalServiceGroups?: Array<number>;
    /**
     * 是否可用 0 不可用，1 可用
     * @type {number}
     * @memberof OrderTypeAdditionServiceRespVo
     */
    enable?: number;
    /**
     * 创建时间
     * @type {string}
     * @memberof OrderTypeAdditionServiceRespVo
     */
    createTime?: string;
    /**
     * 修改时间
     * @type {string}
     * @memberof OrderTypeAdditionServiceRespVo
     */
    updateTime?: string;
    /**
     * 订单类型必选附加服务 [5,6,7,8]
     * @type {Array<number>}
     * @memberof OrderTypeAdditionServiceRespVo
     */
    mustCheckServices?: Array<number>;
    /**
     * 仓库id
     * @type {number}
     * @memberof OrderTypeAdditionServiceRespVo
     */
    warehouseId?: number;
}

/**
 * Check if a given object implements the OrderTypeAdditionServiceRespVo interface.
 */
export function instanceOfOrderTypeAdditionServiceRespVo(value: object): value is OrderTypeAdditionServiceRespVo {
    return true;
}

export function OrderTypeAdditionServiceRespVoFromJSON(json: any): OrderTypeAdditionServiceRespVo {
    return OrderTypeAdditionServiceRespVoFromJSONTyped(json, false);
}

export function OrderTypeAdditionServiceRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderTypeAdditionServiceRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'orderType': json['orderType'] == null ? undefined : json['orderType'],
        'additionalServiceGroups': json['additionalServiceGroups'] == null ? undefined : json['additionalServiceGroups'],
        'enable': json['enable'] == null ? undefined : json['enable'],
        'createTime': json['createTime'] == null ? undefined : json['createTime'],
        'updateTime': json['updateTime'] == null ? undefined : json['updateTime'],
        'mustCheckServices': json['mustCheckServices'] == null ? undefined : json['mustCheckServices'],
        'warehouseId': json['warehouseId'] == null ? undefined : json['warehouseId'],
    };
}

export function OrderTypeAdditionServiceRespVoToJSON(json: any): OrderTypeAdditionServiceRespVo {
    return OrderTypeAdditionServiceRespVoToJSONTyped(json, false);
}

export function OrderTypeAdditionServiceRespVoToJSONTyped(value?: OrderTypeAdditionServiceRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'orderType': value['orderType'],
        'additionalServiceGroups': value['additionalServiceGroups'],
        'enable': value['enable'],
        'createTime': value['createTime'],
        'updateTime': value['updateTime'],
        'mustCheckServices': value['mustCheckServices'],
        'warehouseId': value['warehouseId'],
    };
}

